import Main from './main.vue'
export default Main



// WEBPACK FOOTER //
// ./src/view/main/index.js